<script>
  import { onMount, createEventDispatcher } from "svelte";
  import { fly } from 'svelte/transition';
  import { UserStore, TempUserStore, UserName } from "./store.js";
  import Modal from "../HTMLElements/Modal.svelte";
  import * as objectWrapper from "../Utils/ObjectWrapper.js";
  import * as formValidator from "../Utils/ValidateFormFIelds.js";
  import Field from "../FormField.svelte";
  import Password from "../HTMLElements/PasswordSetter.svelte";
  import wrappedFetch from "../../wrappedFetch.js";
  import Help from "../help.svelte";
  let dispatch = createEventDispatcher();

let isFormValid = true;
let showPrivacyModal = false;
let wrappedObj = $TempUserStore.registerPassword;

const viewPrivacy = async e => {
  e.preventDefault();
  showPrivacyModal = true;
}

  let formError = "";
  let isValidating = false;

  onMount(async function() {
    if (
      $UserStore.registerUser == null ||
      !$UserStore.registerUser.hasCompletedContactDetailsStep
    ) {
      dispatch("pageChange", "/register/start");
    }
  });

  const validate = async e => {
    isFormValid = true;
    isValidating = true;

    e.preventDefault();
    formError = "";
    
    if (wrappedObj.isPrivacyPolicyAgreed.value){
      wrappedObj.isPrivacyPolicyAgreed.isDirty=false;
      wrappedObj.isPrivacyPolicyAgreed.isValid=true;
    }

    if (!formValidator.validate(wrappedObj)) {
      isFormValid = false;
      isValidating = false;
      formError =
        "Please ensure all required fields are completed and confirm that you agree to the privacy policies.";
      wrappedObj = wrappedObj;
      return;
    }

    // if (!wrappedObj.isPrivacyPolicyAgreed.value) {
    //   isFormValid = false;
    //   isValidating = false;
    //   formError = "Please confirm that you agree to the privacy policies.";
    //   return;
    // }  

    // convert TempUserStore to UserStore to send back to the database
    Object.keys($TempUserStore).forEach(function(key) {
      Object.keys($TempUserStore[key]).forEach(function(k) {
        $UserStore.registerUser[k] = $TempUserStore[key][k].value;
      });
    });
    
    let result = await createUser();

    if (result.success) {
      $UserName = result.username;
      dispatch("pageChange", "/register/accountconfirmation");
    } else {
      formError = result.message; 
      isFormValid = false;
    }

    isValidating = false;
  };

  async function createUser() {
    const createUserURL = "user/createaccount";
   
    const resp = await wrappedFetch('user/createaccount', {
        method: 'post',
        body: JSON.stringify($UserStore.registerUser), 
        headers: {
          'Content-Type': 'application/json'
        }
      });

    return await resp.json();
  }

	function navigateBack(){
		dispatch("pageChange", "/register/contactdetails");
	}
</script>

<style>
  .icon {
    padding-top: 10px;
    pointer-events: initial !important;
  }
</style>

<form action="" class="box" autocomplete="off">
  <div class=" field">
    <a href="#" on:click|preventDefault={navigateBack}>
      <span class="fas fa-arrow-left info-icon" />
      Back
    </a>
  </div>

  <h1 class="title is-4">Set Password</h1>
  <Password bind:password={wrappedObj.password} bind:confirmPassword={wrappedObj.confirmPassword} showPolicy='true' isRequired='true' />
  
  <div>
      <div class="field">
        <label class="checkbox" style="margin-top: 10px;">
      <input
        type="checkbox"
        id="privacyPolicy"
        bind:checked={wrappedObj.isPrivacyPolicyAgreed.value} />

          <span>I agree to the</span>
        <a
            href="#"
            on:click={viewPrivacy}
            style="margin-left:4px; cursor: pointer;">
            privacy policy
          </a>
        </label>
  </div>

  <hr />
  {#if !isFormValid}
    <div class="notification is-invalid">
      <p class="help" style="margin-bottom:0px">{@html formError}</p>
    </div>
  {/if}

  <div style="text-align: right;">
    <button type="submit" class="button is-purple {isValidating ? "is-loading" : ""}" on:click={validate} disabled={isValidating}>
      Create
    </button>
  </div>
  
<Modal bind:showModal={showPrivacyModal}>
<Help
  helpId ={'Help16'}
  isPopup={true} />
</Modal>
</form>
